//
//
//
//
//
//
//
//
//

import hasWindow from '~/mixins/hasWindow'

export default {
  mixins: [hasWindow],

  head() {
    return {
      title: 'Produk Pembalut dan Pantyliners Charm | Charmgirlstalk',
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: `Semua produk pembalut charm tersedia di Charm Girl's Talk, mulai dari pembalut Charm Body Fit hingga Charm Pantyliner Long & Wide. Yuk belanja di Charm Girl's Talk!`,
        },
      ],
    }
  },
}
